import React from 'react';

const TeamColorSelector = ({ value, onChange }) => (
  <div className="ocr-team-selector" role="group" aria-label="Screenshot team color">
    {['blue', 'red'].map((color) => (
      <button
        key={color}
        type="button"
        className={`ocr-team-option ocr-team-option--${color} ${value === color ? 'active' : ''}`}
        onClick={() => onChange(color)}
      >
        {color.toUpperCase()}
      </button>
    ))}
  </div>
);

export default TeamColorSelector;
